/**
 * Where to naviagte to when signing up as each user type
 */
export enum AgreementRoute {
  Agent = '/agreement/jp',
  Candidate = '/agreement',
}
